import { compile, match, type MatchFunction } from "path-to-regexp";
import { type Component, getContext } from "svelte";
import { useURL } from "./url.svelte.js";

const matchers: Record<string, MatchFunction<Partial<Record<string, string | string[]>>>> = {};
const compilers: Record<string, (params: Record<string, string | string[]> | undefined) => string> = {};

export function useRoute() {
    const routes = getContext<string[]>("routes");
    const url = useURL();
    const basePath = globalThis.__TURIAN_BASE_PATH__;
    const route = $derived.by(() => {
        let pathname = url.current.pathname;
        if (basePath && pathname.startsWith(basePath)) {
            pathname = pathname.slice(basePath.length) || "/";
        }
        for (const route of routes) {
            const mather = (matchers[route] ??= match(route));
            const m = mather(pathname);
            if (m) {
                return {
                    route,
                    params: m.params,
                };
            }
        }
        return null;
    });

    return {
        get current() {
            return route;
        },
    };
}

export type Page = {
    default: Component;
    route: string;
    sessionRequired?: boolean;
    adminRequired?: boolean;
    organizationRequired?: boolean;
};

export function resolveURL(
    route: string,
    params?: Record<string, string | string[]>,
    query?: Record<string, string | string[]>,
) {
    const compiler = (compilers[route] ??= compile(route));
    const url = new URL(globalThis.__TURIAN_BASE_PATH__ + compiler(params), window.location.toString());
    if (query) {
        for (const [k, v] of Object.entries(query)) {
            if (Array.isArray(v)) {
                for (const x of v) {
                    url.searchParams.append(k, x);
                }
            } else {
                url.searchParams.append(k, v);
            }
        }
    }
    return url;
}

export function resolve(
    route: string,
    params?: Record<string, string | string[]>,
    query?: Record<string, string | string[]>,
) {
    return resolveURL(route, params, query).toString();
}
